import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink, AlertTriangle } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { Button } from '../components/ui/Button';
export function HelpGoogleSheetsPage() {
  return <div className="min-h-screen bg-gray-50" dir="rtl" data-id="element-2010">
      <Navbar data-id="element-2011" />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-2012">
        <Link to="/configure" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6" data-id="element-2013">
          <ArrowRight className="ml-2 w-4 h-4" data-id="element-2014" />
          رجوع إلى الإعدادات
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-2015">
          <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50" data-id="element-2016">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2017">
              كيفية ربط Google Sheets
            </h1>
            <p className="text-gray-600" data-id="element-2018">
              اتبع الخطوات التالية للحصول على Client ID و Client Secret من
              Google Cloud Console
            </p>
          </div>

          <div className="p-8 space-y-8" data-id="element-2019">
            {/* Warning */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 flex items-start gap-3" data-id="element-2020">
              <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-2021" />
              <div className="text-sm text-yellow-800" data-id="element-2022">
                <strong data-id="element-2023">تحذير أمني:</strong> لا تشارك Client Secret مع أي شخص.
                احتفظ به في مكان آمن.
              </div>
            </div>

            {/* Steps */}
            <div className="space-y-6" data-id="element-2024">
              <div className="flex gap-4" data-id="element-2025">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-2026">
                  1
                </div>
                <div className="flex-1" data-id="element-2027">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2028">
                    افتح Google Cloud Console
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2029">
                    انتقل إلى{' '}
                    <a href="https://console.cloud.google.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline inline-flex items-center gap-1" data-id="element-2030">
                      Google Cloud Console
                      <ExternalLink size={14} data-id="element-2031" />
                    </a>
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2032">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2033">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-2034">
                  2
                </div>
                <div className="flex-1" data-id="element-2035">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2036">
                    أنشئ مشروع جديد أو اختر مشروع موجود
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2037">
                    من القائمة العلوية، اضغط على اسم المشروع واختر "New Project"
                    أو اختر مشروعاً موجوداً.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2038">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2039">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-2040">
                  3
                </div>
                <div className="flex-1" data-id="element-2041">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2042">
                    فعّل Google Sheets API
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2043">
                    اذهب إلى "APIs & Services" → "Enable APIs and Services" →
                    ابحث عن "Google Sheets API" وفعّله.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2044">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2045">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-2046">
                  4
                </div>
                <div className="flex-1" data-id="element-2047">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2048">
                    أنشئ OAuth 2.0 Credentials
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2049">
                    اذهب إلى "Credentials" → "Create Credentials" → "OAuth
                    client ID"
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-1 mb-3" data-id="element-2050">
                    <li data-id="element-2051">Application type: Web application</li>
                    <li data-id="element-2052">Name: Operiens Integration</li>
                    <li data-id="element-2053">
                      Authorized redirect URIs: أضف الرابط من صفحة الإعدادات
                    </li>
                  </ul>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2054">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2055">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold" data-id="element-2056">
                  5
                </div>
                <div className="flex-1" data-id="element-2057">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2058">
                    انسخ Client ID و Client Secret
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2059">
                    بعد إنشاء الـ OAuth client، ستظهر لك نافذة تحتوي على Client
                    ID و Client Secret. انسخهما والصقهما في صفحة الإعدادات.
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2060">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>
            </div>

            {/* Video Tutorial */}
            <div className="border-t border-gray-100 pt-8" data-id="element-2061">
              <h3 className="font-bold text-gray-900 mb-4" data-id="element-2062">شرح بالفيديو</h3>
              <div className="bg-gray-100 rounded-lg aspect-video flex items-center justify-center text-gray-500" data-id="element-2063">
                [فيديو يوتيوب - سيتم إضافته]
              </div>
            </div>

            {/* CTA */}
            <div className="border-t border-gray-100 pt-8" data-id="element-2064">
              <Link to="/configure" data-id="element-2065">
                <Button size="lg" fullWidth data-id="element-2066">
                  رجوع إلى الإعدادات
                  <ArrowRight className="mr-2 w-5 h-5" data-id="element-2067" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>;
}